module.exports = __webpack_public_path__ + "img/bg-bottom-right.64b07e5d.png";